<template>
    <div class="survey-success">
        <div>
            설문에 응해주셔서 감사합니다.
        </div>
        <button class="button" @click="$router.back()">
            제출한 답변 확인하기
        </button>
    </div>
</template>

<script>
export default {
    name: "Success",
    data: () => ({}),
    beforeDestroy() {
        // this.$router.push("/success");
    }
};
</script>

<style lang='scss'>
@import "../styles/color";

.survey-success {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 18px;
    font-weight: bold;
    color: #5e616e;
    .button {
        margin-top: 36px;
        font-size: 13px;
        padding: 16px 22px;
        @extend %background_gradiant;
        border-radius: 24px;
        color: #fff;
        border: none;
        outline: none;
    }
}
</style>
